import { Book, Facebook, FacebookIcon, Globe, GraduationCap, Link2Icon, Linkedin, LinkedinIcon, LucideFacebook, LucideTwitter, LucideYoutube, Music, Twitter, TwitterIcon, User, Users, Youtube, YoutubeIcon } from "lucide-vue-next";
import xpertlogo from "./assets/xpertlogo.png";
import Admission from "./assets/Admission.jpg";
import carousel1 from "./assets/carousel1.jpg";
import carousel2 from "./assets/carousel2.jpg";
import carousel3 from "./assets/carousel3.jpg";
import pexel from "./assets/pexel.jpg";
import teachers from "./assets/teachers.png";
import std1 from "./assets/std1.png";
import courses from "./assets/courses.png";
import trophy4 from "./assets/trophy4.png";
import principle from "./assets/principle.jpg";
import principle1 from "./assets/principle1.jpg";
import principle2 from "./assets/principle2.jpg";
import vice from "./assets/vice.jpg";
import screen from './assets/video.mp4';

 
const theme = {
  theme: {
    colors: {
      primary: "#FFB606",
      secondary: "#FF0066",
      textPrimary: "#1E1E1E",
      textSecondary: "#6B6B6B",
      background: "#FFFFFF",
      footerBackground: "#0B1120"
    },
    fonts: {
      heading: "Poppins, sans-serif",
      body: "Roboto, sans-serif"
    },
    buttons: {
      primary: {
        background: "#FFB606",
        textColor: "#FFFFFF",
        hoverBackground: "#E0A000"
      },
      secondary: {
        background: "#FF0066",
        textColor: "#FFFFFF",
        hoverBackground: "#CC0055"
      }
    }
  },

  header: {
    topbar: {
      email: "info@theacademy.com",
      phone: "+123 456 7890",
      socialLinks: {
        facebook: "https://facebook.com",
        twitter: "https://twitter.com",
        linkedin: "https://linkedin.com"
      }
    },
    logo: xpertlogo,
    menu: [
      { label: "Home", link: "/" },
      { label: "About Us", link: "/about" },
      { label: "Programs", link: "/programs" },
      { label: "Events", link: "/events" },
      { label: "Contact", link: "/contact" }
    ],
    ctaButton: {
      label: "Enroll Now",
      link: "/register"
    }
  },

  heroSection: {
    backgroundImage: "/images/hero.jpg",
    title: "Best Online Training Course",
    subtitle: "Join our academy for top-class learning experiences",
    ctaText: "Get Started",
    ctaLink: "/register"
  },

  features: [
    {
      icon: "book",
      title: "Books & Library",
      description: "Access thousands of books and study materials."
    },
    {
      icon: "video",
      title: "Online Courses",
      description: "Learn at your own pace from industry experts."
    },
    {
      icon: "certificate",
      title: "Expert Instructors",
      description: "Highly qualified teachers with years of experience."
    },
    {
      icon: "online",
      title: "Online Education",
      description: "Interactive and engaging online sessions."
    },
    {
      icon: "star",
      title: "Best Education",
      description: "Top-rated courses for your career growth."
    },
    {
      icon: "shield",
      title: "Scholarship",
      description: "Merit-based scholarships available."
    }
  ],

  aboutUs: {
    title: "About Us",
    description:
      "We provide world-class education through online and offline platforms, empowering students to achieve academic and professional excellence.",
    stats: {
      students: 260,
      courses: 152
    },
    videoThumbnail:carousel1,
    videoLink: "https://youtube.com/sample-video"
  },

  programs: [
    {
      image: "/images/program1.jpg",
      title: "Full Stack Web Development",
      instructor: "John Doe",
      description: "Learn HTML, CSS, JS, and backend technologies...",
      link: "/programs/full-stack"
    },
    {
      image: "/images/program2.jpg",
      title: "Data Science & AI",
      instructor: "Mary Jane",
      description: "Master Python, Machine Learning, and AI tools...",
      link: "/programs/data-science"
    }
  ],

  events: [
    {
      date: "25 Aug",
      title: "Student Orientation Program",
      description: "Welcome session for new students...",
      link: "/events/orientation"
    },
    {
      date: "12 Sep",
      title: "Web Development Bootcamp",
      description: "Learn to build modern web apps...",
      link: "/events/web-bootcamp"
    }
  ],

  team: [
    {
      name: "Prof. Dr. Shah",
      role: "Vice Chancellor",
      photo: "/images/dr-shah.jpg"
    },
    {
      name: "Atif Ali",
      role: "Principal",
      photo: "/images/atif-ali.jpg"
    }
  ],

  campuses: [
    {
      name: "Boys Campus",
      address: "123 Main Street, City",
      image: "/images/boys-campus.jpg"
    },
    {
      name: "Girls Campus",
      address: "456 College Road, City",
      image: "/images/girls-campus.jpg"
    },
    {
      name: "Main Campus",
      address: "789 University Ave, City",
      image: "/images/main-campus.jpg"
    }
  ],

  contact: {
    form: {
      namePlaceholder: "Enter your name",
      emailPlaceholder: "Enter your email",
      messagePlaceholder: "Type your message",
      submitLabel: "Send Message"
    },
    image: "/images/contact.jpg"
  },

  teachers: [
    {
      name: "Albert Min",
      subject: "Mathematics",
      image: "/images/albert.jpg",
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Emily Clark",
      subject: "Computer Science",
      image: "/images/emily.jpg",
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "David Liu",
      subject: "Physics",
      image: "/images/david.jpg",
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Nicole Ray",
      subject: "English Literature",
      image: "/images/nicole.jpg",
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  ],

  testimonials: [
    {
      name: "Liza Grace",
      text: "This platform helped me excel in my studies and improve my skills.",
      image: "/images/student1.jpg"
    },
    {
      name: "James Smith",
      text: "The teachers are amazing and the content is top-notch.",
      image: "/images/student2.jpg"
    },
    {
      name: "Sara Khan",
      text: "I learned so much in such a short period of time. Highly recommended!",
      image: "/images/student3.jpg"
    }
  ],


  whyChooseUs: {
    title: "Why Choose Us?",
    subtitle: "We are dedicated to providing the best educational experience.",
    cards: [
      { icon: "Book", title: "Comprehensive Curriculum", description: "A well-rounded curriculum that covers all essential topics." },
      { icon: "Globe", title: "Global Reach", description: "Connecting students from around the world." },
      { icon: "User", title: "Experienced Instructors", description: "Learn from industry experts with years of experience." },
      { icon: "Users", title: "Community Support", description: "Join a vibrant community of learners and educators." },
      { icon: "Music", title: "Engaging Content", description: "Interactive and engaging learning materials." },
      { icon: "GraduationCap", title: "Career Focused", description: "Courses designed to enhance your career prospects." }
    ]
  },
  AboutUs:{
    title: "About Us",
    description: "We are a leading online education platform, committed to providing high-quality learning experiences.We are a leading online education platform, committed to providing high-quality learning experiences. ",
    image: "/src/assets/carousel1.jpg",
    video:screen,
  },
  PopularCoursesSection: {
  title: "Popular Courses",
  subtitle: "Explore our most popular courses",
  cards:[
      {
        title: 'Web Development Masterclass',
        description: 'Learn to build modern web applications from scratch with HTML, CSS, JavaScript, and popular frameworks. This comprehensive course covers everything you need to know to become a full-stack developer.',
        rating: 4,
        students: '1.2K',
        views: '5.8K',
        instructorName: 'Jane Doe',
        price: 'Free',
      },
      {
        title: 'Data Science with Python',
        description: 'Dive into data analysis, machine learning, and visualization using Python and its powerful libraries. Explore real-world datasets and build predictive models.',
        rating: 5,
        students: '950',
        views: '4.2K',
        instructorName: 'John Smith',
        price: '$49.99',
      },
      {
        title: 'Digital Marketing Fundamentals',
        description: 'Master the essentials of digital marketing, SEO, social media, and content strategy to grow your brand. Learn to create effective online campaigns.',
        rating: 3,
        students: '780',
        views: '3.1K',
        instructorName: 'Emily White',
        price: '$29.99',
      },
      {
        title: 'Graphic Design for Beginners',
        description: 'Unleash your creativity and learn the basics of graphic design, including tools like Adobe Photoshop and Illustrator. Develop a strong foundation in visual communication.',
        rating: 4,
        students: '1.1K',
        views: '6.5K',
        instructorName: 'Michael Brown',
        price: 'Free',
      },
      {
        title: 'Mobile App Development (React Native)',
        description: 'Build cross-platform mobile applications for iOS and Android using React Native and JavaScript. Learn to create engaging user interfaces and robust backends.',
        rating: 5,
        students: '890',
        views: '4.9K',
        instructorName: 'Sarah Green',
        price: '$59.99',
      },
      {
        title: 'Photography Essentials',
        description: 'Learn the art of photography, from camera basics to advanced composition and editing techniques. Capture stunning images and express your artistic vision.',
        rating: 4,
        students: '620',
        views: '2.7K',
        instructorName: 'David Lee',
        price: '$34.99',
      },
    ],
  },
  StaticBanner: [
  {
    image: std1,
    count: '1800+',
    label: 'Students',
  },
  {
    image: courses,
    count: '70',
    label: 'Courses',
  },
  {
    image: teachers,
    count: '700+',
    label: 'Certified Teachers',
  },
  {
    image: trophy4,
    count: '1200+',
    label: 'Award Winning',
  }],
  UpcomingEventSection: {
    title: "Upcoming Events",
    subtitle: "Join our upcoming events and workshops to enhance your skills",
    cards: [
      {
    id: 1,
    date: "October 26, 2024",
    instructor: "John Doe",
    location: "Online",
    title: "Introduction to AI in Design",
    time: "10:00 AM - 12:00 PM PST",
    description: "Explore the basics of artificial intelligence and its applications in modern design workflows.",
    image: carousel1, // Changed to 'image'
  },
  {
    id: 2,
    date: "November 10, 2024",
    instructor: "Jane Smith",
    location: "New York City",
    title: "Advanced React Patterns",
    time: "09:00 AM - 05:00 PM EST",
    description: "Dive deep into advanced React patterns, hooks, and performance optimization techniques.",
    image:carousel2, // Changed to 'image'
  },
  {
    id: 3,
    date: "December 05, 2024",
    instructor: "Alice Johnson",
    location: "Virtual Conference",
    title: "Web Accessibility Best Practices",
    time: "01:00 PM - 03:00 PM GMT",
    description: "Learn how to build inclusive web experiences that are accessible to all users.",
    image: pexel, // Changed to 'image'
  },
   {
    id: 4,
    date: "December 05, 2024",
    instructor: "Alice Johnson",
    location: "Virtual Conference",
    title: "Web Accessibility Best Practices",
    time: "01:00 PM - 03:00 PM GMT",
    description: "Learn how to build inclusive web experiences that are accessible to all users.",
    image: teachers, // Changed to 'image'
  }

]
  
 
  },
  Principle:
    [
  {
    title: 'Vice Chancellor',
    name: 'Prof. Dr.  Shah',
    image:principle1,
    borderColor: '#FDB813', // Orange
  },
  {
    title: 'Chancellor',
    name: 'Asif Ali ',
    image: principle2,
    borderColor: '#007BFF', // Blue
  },
],
Campuses:{
  title: "Our Campuses",
  subtitle: "Explore our campuses and facilities",
  Card:  [
  {
    name: 'Boys Campus',
    image: carousel1,
    description: 'Our flagship campus in the heart of New York City, offering diverse programs and industry connections.',
  },
  {
    name: 'Girls Campus',
    image: carousel3,
    description: 'Experience world-class education in the historic and culturally rich city of London.',
  },
  {
    name: 'Main Campus',
    image: carousel3,
    description: 'A modern campus in sunny Sydney, providing a dynamic learning experience by the coast.',
  }
 
]  
},
 Teachers : [
  {
    name: 'Aden Smith',
    title: 'Head Of Department',
    image: pexel,
    socials: {
      Facebook: '#',
      TwitterIcon: '#',
      Link2Icon: '#',
      Youtube: '#'
    }
  },
  {
    name: 'Kally Brooks',
    title: 'Professor',
    image: pexel,
    socials: {
      FacebookIcon: '#',
      Twitter: '#',
      LinkedinIcon: '#',
      YoutubeIcon: '#'
    }
  },
  {
    name: 'David Clark',
    title: 'Chemistry Teacher',
    image: pexel,
    socials: {
      LucideFacebook: '#',
      LucideTwitter: '#',
      Linkedin: '#',
      LucideYoutubee: '#'
    }
  },
  {
    name: 'Rebeka Alig',
    title: 'English Teacher',
    image: pexel,
    socials: {
      facebook: '#',
      twitter: '#',
      linkedin: '#',
      youtube: '#'
    }
  }
],
testimonialsData:  [
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: Admission,
    borderColor: '#87CEEB', // Light Blue
  },
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: carousel1,
    borderColor: '#FFB6C1', // Light Pink
  },
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: carousel3,
    borderColor: '#87CEEB', // Light Blue
  },
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: carousel1,
    borderColor: '#FFB6C1', // Light Pink
  },
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: Admission,
    borderColor: '#87CEEB', // Light Blue
  },
  {
    name: 'Lissa Castro',
    title: 'Co-Founder',
    quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaerillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    image: carousel1,
    borderColor: '#FFB6C1', // Light Pink
  },
],
footerData : {
  siteName: 'TheGuiders',
 
  description: 'Phasellus blandit massa enim. elit id varius nunc. Lorem ipsum dolor sit amet, consectetur industry.',
  address: 'California Street San Francisco, CA',
  email: 'info@sitename.com',
  phone: '+ 457 789 789 65',

  usefulLinks: [
    { name: 'Join Us', href: '#' },
    { name: 'About Us', href: '#' },
    { name: 'Features', href: '#' },
    { name: 'Feedback', href: '#' },
    { name: 'Support center', href: '#' },
    { name: 'Contact Us', href: '#' },
  ],

  recentPosts: [
    { image: pexel, title: 'Lorem ipsum dolor sit amet, consectetur', date: 'April 14, 2018' },
    { image:carousel2, title: 'Lorem ipsum dolor sit amet, consectetur', date: 'April 14, 2018' },
    { image: carousel3, title: 'Lorem ipsum dolor sit amet, consectetur', date: 'April 14, 2018' },
  ],

  socialLinks: [
    { icon: 'Facebook', name: 'Facebook', href: 'https://facebook.com' },
    { icon: 'Twitter', name: 'Twitter', href: 'https://twitter.com' },
    { icon: 'Instagram', name: 'Instagram', href: 'https://instagram.com' },
    { icon: 'Linkedin', name: 'LinkedIn', href: 'https://linkedin.com' },
    { icon: 'Youtube', name: 'YouTube', href: 'https://youtube.com' },
  ],
},
};

export default theme;
